<div class="label">{{ label | translate }}</div>
<div class="content">
  <div #contentProjection><ng-content></ng-content></div>
  @if ((hasContentProjection$ | async) === false && value !== 'undefined' && value !== null) {
    {{ value }}
  }
  @if ((hasContentProjection$ | async) === false && (value === 'undefined' || value === null)) {
    {{ noContentDisplay }}
  }
</div>
